import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { SigningUrlGetPayload } from 'Interfaces/Document';
import { $actions } from 'Store';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: SigningUrlGetPayload) =>
    $actions.documentSign.getSigningUrl(dispatch, payload),
  );
};
